import React from 'react'
import customRequest from '../../../../../helpers/customRequest'
import redirect from '../../../../../components/redirect/redirect'
import message from '../../../../../components/message/message'
import buildQuery from '../../../../../helpers/buildQuery'

class Manage extends React.Component
{
    state = {
        loading: true,
        delegations: [
            {
                used: 2,
                username: "username",
                delegated: 1
            }
        ]
    }
    componentDidMount() {
        customRequest.get('/api/subscription/share')
        .then(({data: delegations}) => {

            if (delegations.valid == false) {
                return redirect.send("/account/subscription", () => {
                    message.error(delegations.message)
                })
            }

            if (delegations.length == 0) {
                return redirect.send("/account/subscription", () => {
                    message.error("You do not currently have any student licenses you are sharing to other users.")
                })
            }

            this.setState({loading: false, delegations: delegations})
        })

    }

    render()
    {
        var { delegations } = this.state

        return (
            <React.Fragment>
                <h1 class = "subheader-text">Manage Subscription Sharing</h1>
                <form class = "form-horizontal form-validate" noValidate method = "get" action = "../revoke">
                    <ul id = "checkbox-list" class = "list-group text-left">
                        {delegations.map((delegation) =>
                        {
                            return <li class = "list-group-item action-list">
                                <input class = "checkbox-list-item" type = "checkbox" id = {`checkbox-${delegation.username}`} name = "delegations[]" value = {delegation.user} />
                                
                                <label class = "break-words" role = "button" for = {`checkbox-${delegation.user}`}><strong>{delegation.delegated} student{delegation.delegated > 1 ? "s" : ""}</strong> delegated to <strong>{delegation.username}</strong> ({delegation.used} Used)</label>
                                
                                <span class = "float-right">
                                    <a href = {`edit?${buildQuery({'user': delegation.username})}`} class = "action-link">Edit</a>
                                </span>
                            </li>
                        })
                        }
                    </ul>
                    
                    <div class = "row mt-3">
                        <div class = "col-12 text-left">
                            <input class = "checkbox-shortcut" type = "checkbox" id = "checkbox-shortcut" />
                            
                            <label role = "button" for = "checkbox-shortcut">Select all</label>
                        </div>
                    </div>
                    
                    <div class = "row">
                        <div class = "col-12 subheader-text">
                            <p>To revoke a subscription, please <a href="https://greatleaps.com/pages/contact-us" target="_blank">contact us</a></p>
                        </div>
                    </div>
                </form>

            </React.Fragment>
        )
    }
}

export default Manage
